<script lang="ts">
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import { Auth } from "@utils/Auth.svelte.js";
	import { getTranslate } from "@utils/getTranslate.js";
	import { AuthenticationModalKind } from "@core/schema/AuthenticationModalKind.js";
	import { CategoryType } from "@core/schema/CategoryType.js";
	import { getCategoryPath } from "@core/schema/paths/getCategoryPath.js";
	import { getSubscriptionPagePath } from "@core/schema/paths/getSubscriptionPagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import MembershipBenefitCard from "./MembershipBenefitCard.svelte";
	import { MembershipBenefitCardVariant } from "./MembershipBenefitCardVariant.js";
	import translations from "./MembershipBenefitSection.translations.json" with { type: "json" };

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);

	const benefits = {
		noMembership: [{ items: [translate("noMembershipBenefits0"), translate("noMembershipBenefits1")] }],
		fathersFamily: [
			{
				heading: translate("fathersFamilyBenefitsCRHeading"),
				items: [translate("fathersFamilyBenefits0"), translate("fathersFamilyBenefits1")],
			},
			{
				heading: translate("fathersFamilyBenefitsEUHeading"),
				items: [translate("fathersFamilyBenefits2"), translate("fathersFamilyBenefits3")],
			},
		],
		longTermSubscription: [
			{
				items: [
					translate("longTermSubscriptionBenefits0"),
					translate("longTermSubscriptionBenefits1"),
					translate("longTermSubscriptionBenefits2"),
					translate("longTermSubscriptionBenefits3"),
					translate("longTermSubscriptionBenefits4"),
				],
			},
		],
	};
</script>

<section class="flex flex-wrap justify-center gap-x-2.5 gap-y-2 -mt-30 z-10">
	<MembershipBenefitCard
		title={translate("noMembershipTitle")}
		variant={MembershipBenefitCardVariant.White}
		benefits={benefits.noMembership}
	>
		{#snippet button()}
			<Link
				href={getCategoryPath(tenant.locale, CategoryType.Coffee)}
				class="w-full mt-5"
				variant={ButtonVariant.White}
				size={ButtonSize.Medium}
			>
				<Formatted text={translate("noMembershipAction")} />
			</Link>
		{/snippet}
	</MembershipBenefitCard>
	<MembershipBenefitCard
		title={translate("basicMembershipTitle")}
		variant={MembershipBenefitCardVariant.Brown}
		benefits={benefits.fathersFamily}
	>
		{#snippet button()}
			<Button
				class="w-full mt-5"
				variant={ButtonVariant.White}
				size={ButtonSize.Medium}
				disabled={Auth.signedIn}
				onclick={async (): Promise<void> => {
					await Auth.openAuthenticationModal(AuthenticationModalKind.Register, {});
				}}
			>
				{#if Auth.signedIn}
					<Formatted text={translate("basicMembershipDisabled")} />
				{:else}
					<Formatted text={translate("basicMembershipAction")} />
				{/if}
			</Button>
		{/snippet}
	</MembershipBenefitCard>
	<MembershipBenefitCard
		subheading={translate("longTermMembershipSubheading")}
		title={translate("longTermMembershipTitle")}
		variant={MembershipBenefitCardVariant.Blue}
		benefits={benefits.longTermSubscription}
		class="col-span-1 md:col-span-2 xl:col-span-1"
	>
		{#snippet button()}
			<Link
				href={getSubscriptionPagePath(tenant)}
				class="w-full mt-5"
				variant={ButtonVariant.White}
				size={ButtonSize.Medium}
			>
				<Formatted text={translate("longTermMembershipAction")} />
			</Link>
		{/snippet}
	</MembershipBenefitCard>
</section>
